import { IconSize, IconSizeType, InfoCircleIcon } from '@prophecy/icons';

import { Tooltip, TooltipProps } from '../Tooltip';

type HintProps = Omit<TooltipProps, 'children'> & {
  size?: IconSizeType;
  color?: string;
  className?: string;
  iconProps?: Partial<React.ComponentProps<typeof InfoCircleIcon>>;
};

export type HintPropsType = string | Omit<HintProps, 'iconProps'>;

export function Hint({ placement = 'top', color, size = IconSize.s, iconProps, className, ...restProps }: HintProps) {
  return (
    <Tooltip placement={placement} {...restProps}>
      <span>
        <InfoCircleIcon type='default' size={size} color={color} className={className} {...iconProps} />
      </span>
    </Tooltip>
  );
}
